// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"AssigneesToolbar_Breadcrumbs__Q3XsA","BreadcrumbsLoadingSpinner":"AssigneesToolbar_BreadcrumbsLoadingSpinner__bWaji"};